import * as Turbo from '@hotwired/turbo';
import { Application } from "@hotwired/stimulus"

// Import controllers
import ShareUrlController from "../controllers/share_url_controller"
import CameraSelectorController from "../controllers/camera_selector_controller"
import UserSelectorController from "../controllers/user_selector_controller"
import AutoRefreshController from "../controllers/auto_refresh_controller"
import NotificationPermissionController from "../controllers/notification_permission_controller"
import SearchController from "../controllers/search_controller"
import FullscreenController from "../controllers/fullscreen_controller"
import CameraMapController from "../controllers/camera_map_controller"
import FeatureToggleController from '../controllers/feature_toggle_controller';
import ObjectDetectionController from '../controllers/object_detection_controller'
import CameraObjectDetectionController from "../controllers/camera_object_detection_controller"
import WebrtcConnectionController from "../controllers/webrtc_connection_controller"
import CameraOrgController from "../controllers/camera_org_controller"

Turbo.start()

declare global {
  interface Window {
    Stimulus: Application;
  }
}

const application = Application.start()

// Register controllers
application.register("share-url", ShareUrlController)
application.register("camera-selector", CameraSelectorController)
application.register("user-selector", UserSelectorController)
application.register("auto-refresh", AutoRefreshController)
application.register("notification-permission", NotificationPermissionController)
application.register("search", SearchController)
application.register("fullscreen", FullscreenController)
application.register("camera-map", CameraMapController)
application.register("feature-toggle", FeatureToggleController)
application.register("object-detection", ObjectDetectionController)
application.register("camera-object-detection", CameraObjectDetectionController)
application.register("webrtc-connection", WebrtcConnectionController)
application.register("camera-org", CameraOrgController)

document.addEventListener("turbo:load", (event) => {
  document.querySelectorAll("[data-href]").forEach((element) => {
    element.addEventListener("click", (event) => {
      const href = element.getAttribute("data-href")
      if (href) {
        event.preventDefault()
        Turbo.visit(href)
      }
    })
  })
})